import React, { useContext } from "react";
import { IMAGE_TYPE } from "./../../ricos-content/index.js";
import { RicosContext, RicosViewerContext } from "./../../ricos-context/index.js";
import { ViewerFigure } from "../../_shared/figure/viewer-figure.js";
import { Image } from "./image.js";
const ViewerImage = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer
}) => {
  const { config: viewerConfig, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile } = useContext(RicosContext);
  const config = viewerConfig[IMAGE_TYPE] ?? {};
  const expand = getExpandFunction({
    helpers,
    config,
    nodeId: node.id,
    imageData: node.imageData
  });
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: node.imageData,
    config,
    expand
  });
  return /* @__PURE__ */ React.createElement(
    ViewerFigure,
    {
      node,
      nodeIndex,
      NodeViewContainer,
      RicosNodesRenderer
    },
    /* @__PURE__ */ React.createElement(
      Image,
      {
        node,
        imageClickActionConfig,
        expand,
        config,
        seoMode,
        helpers,
        isMobile,
        shouldLazyLoadImages: true
      }
    )
  );
};
const ImageRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ViewerImage, { key: node.id, node, ...props });
};
var viewer_image_default = ImageRenderer;
const getImageClickActionConfig = ({
  imageData,
  config,
  expand
}) => {
  if (imageData?.link?.url && config) {
    return { type: "link" };
  }
  if (imageData?.link?.anchor) {
    return { type: "anchor" };
  }
  if (expand) {
    return { type: "expand", onClick: expand };
  }
  return { type: "regular" };
};
const getExpandFunction = ({
  helpers,
  config,
  nodeId,
  imageData
}) => {
  const { onExpand, disableExpand } = config;
  if (imageData?.disableExpand === true || disableExpand === true || !onExpand) {
    return;
  }
  return (e) => {
    e.preventDefault();
    e.stopPropagation();
    helpers.onViewerAction?.(IMAGE_TYPE, "Click", "expand_image");
    onExpand(nodeId);
  };
};
export {
  ViewerImage,
  viewer_image_default as default
};
//# sourceMappingURL=viewer-image.js.map
